<template>
  <div class="flex justify-end">
    <div class="max-w-[80%] rounded-2xl rounded-br-sm bg-light-fg-accent px-3 py-2 text-base font-normal leading-6 text-white">
      {{ text }}
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  text: string;
}

defineProps<Props>();
</script>
